<router-outlet></router-outlet>
<platform-scroll-top></platform-scroll-top>
<skudo-script-injector-statuspage></skudo-script-injector-statuspage>
<skudo-global-loading [isEnabled]="isLoading" [isInitialLoad]="isInitialLoad"></skudo-global-loading>
